import React from 'react';
import { Row, Col } from 'react-bootstrap';

import { format } from 'date-fns';
import Text from '../../../components/Text';
import Card from '../../../components/Card';

// eslint-disable-next-line no-unused-vars
export default function TransactionCard({ myTransaction, ...props }) {
  function Header() {
    return (
      <Text color="#464E5F" type="header">
        Transação
      </Text>
    );
  }

  function showTransactionType() {
    return myTransaction.points > 0 ? 'Crédito' : 'Débito';
  }

  return (
    <Col lg={6} md={6} xs={12}>
      <Card
        header={<Header />}
        HeaderRightComponent={
          <Text type="label" color="gray" className="mr-2">
            {format(new Date(myTransaction.created_at), 'dd/MM/yyyy')} -{' '}
            {showTransactionType()}
          </Text>
        }
      >
        <Row>
          <Col xs={12} md={6}>
            <Text className="load-label-align mb-2">CPF</Text>
            <Text color="gray" type="regular" className="d-block mb-4">
              {myTransaction.cpf}
            </Text>
          </Col>
          <Col xs={12} md={6}>
            <Text className="load-label-align mb-2">Pontos</Text>
            <Text color="gray" type="regular" className="d-block mb-4">
              {myTransaction.points}
            </Text>
          </Col>
          <Col xs={12}>
            <Text className="load-label-align mb-2">Produto</Text>
            <Text color="gray" type="regular" className="d-block mb-4">
              {JSON.parse(myTransaction.products)
                .map(product => `${product.name}`)
                .join(', ')}
            </Text>
          </Col>
          {myTransaction.description && (
            <Col xs={12}>
              <Text className="load-label-align mb-2">Descrição</Text>
              <Text color="gray" type="regular" className="d-block mb-4">
                {myTransaction.description}
              </Text>
            </Col>
          )}
        </Row>
      </Card>
    </Col>
  );
}
